import { useState } from "react";
import type { ReactNode } from "react";

import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  AccordionProps,
  Box,
  Button,
  Checkbox,
  Flex,
  Heading,
  Input,
  Radio,
  RadioGroup,
  Stack,
  HStack,
  VStack,
  StackProps,
} from "@chakra-ui/react";

import { SelectOption } from "components/global/select";

interface SidebarFilterProps extends AccordionProps {
  defaultIndex?: Array<number>;
  children?: ReactNode;
}

interface SidebarContentProps extends StackProps {
  children?: ReactNode;
}

const SidebarContent = (props: SidebarFilterProps): JSX.Element => {
  const { children } = props;

  return (
    <VStack
      p={1}
      spacing={3}
      align={"stretch"}
      maxHeight="350px"
      overflowY={"auto"}
    >
      {children}
    </VStack>
  );
};

export const SidebarFilter = (props: SidebarFilterProps): JSX.Element => {
  const { defaultIndex = [0], children, ...otherProps } = props;
  return (
    <Accordion
      defaultIndex={defaultIndex}
      allowMultiple
      {...otherProps}
      variant={"filter"}
    >
      {children}
    </Accordion>
  );
};

export const SidebarFilterStatus = (): JSX.Element => {
  const status = [
    {
      label: "Buy Now",
      value: "buy_now",
    },
    {
      label: "On Auction",
      value: "on_auction",
    },
    {
      label: "New",
      value: "new",
    },
    {
      label: "Has Offers",
      value: "has_offers",
    },
  ];
  return (
    <AccordionItem>
      <AccordionButton>
        <Box flex="1" textAlign="left">
          Status
        </Box>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel pb={4}>
        <SidebarContent>
          {status.map((item, index) => (
            <Checkbox
              value={item.value}
              key={index}
              size="lg"
              display={"block"}
            >
              {item.label}
            </Checkbox>
          ))}
        </SidebarContent>
      </AccordionPanel>
    </AccordionItem>
  );
};

export const SidebarFilterPrice = (): JSX.Element => {
  const optionCurrency = [
    {
      label: "USD",
      value: "usd",
    },
    {
      label: "ETH",
      value: "eth",
    },
    {
      label: "SOL",
      value: "sol",
    },
  ];

  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left">
            Price
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <SidebarContent>
          <Box>
            <HStack spacing={2} mb={2}>
              <Box width={"fit-content"} flexShrink={0}>
                <SelectOption maxW="full" options={optionCurrency} />
              </Box>
              <Box>
                <Input placeholder="Min" />
              </Box>
              <Box fontWeight={"bold"}>to</Box>
              <Box>
                <Input placeholder="Max" />
              </Box>
            </HStack>
            <Button width={"full"} variant="purple">
              Apply
            </Button>
          </Box>
        </SidebarContent>
      </AccordionPanel>
    </AccordionItem>
  );
};

export const SidebarFilterQuantity = (): JSX.Element => {
  const status = [
    {
      label: "All items",
      value: "all_item",
    },
    {
      label: "Singel items",
      value: "singel_item",
    },
    {
      label: "Bundles",
      value: "bundle",
    },
  ];
  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left">
            Item Quantity
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <SidebarContent>
          <RadioGroup defaultValue={"all_item"}>
            <Stack>
              {status.map((item, index) => (
                <Radio value={item.value} size="lg" key={index}>
                  {item.label}
                </Radio>
              ))}
            </Stack>
          </RadioGroup>
        </SidebarContent>
      </AccordionPanel>
    </AccordionItem>
  );
};

export const SidebarFilterCategory = (): JSX.Element => {
  const categories = [
    {
      label: "Art",
      value: "art",
    },
    {
      label: "Collectibles",
      value: "collectibles",
    },
    {
      label: "Domain Names",
      value: "domain_names",
    },
    {
      label: "Music",
      value: "music",
    },
    {
      label: "Photography",
      value: "photography",
    },
    {
      label: "Sports",
      value: "sports",
    },
    {
      label: "Trading Cards",
      value: "trading_cards",
    },
    {
      label: "Utility",
      value: "utility",
    },
    {
      label: "Virtual Worlds",
      value: "virtual_worlds",
    },
  ];
  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left">
            Category
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <SidebarContent>
          {categories.map((item, index) => (
            <Checkbox
              value={item.value}
              key={index}
              size="lg"
              display={"block"}
            >
              {item.label}
            </Checkbox>
          ))}
        </SidebarContent>
      </AccordionPanel>
    </AccordionItem>
  );
};
